var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.222 0H1.777C.792 0 .01.8.01 1.778L0 14.222A1.778 1.778 0 001.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0zm0 14.222H1.778V5.333h12.444v8.89zm0-10.666H1.778V1.778h12.444v1.778zM5.333 8.889H3.556V7.11h1.777V8.89zm3.556 0H7.11V7.11H8.89V8.89zm3.555 0h-1.777V7.11h1.777V8.89zm-7.11 3.555H3.555v-1.777h1.777v1.777zm3.555 0H7.11v-1.777H8.89v1.777z",
    fill: "#2A848E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default ForwardRef;